const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('../core/apiURLBuilder');
const Api = require('../services/api');
const formActions = require('react-redux-form').actions;
import { formatText } from 'core/i18n';

const getCorreosBranchesByLatLongService = (dispatch, lat, long, callback) => {
    Api.get(apiURLBuilder.getURL('getPostOfficesByLatLong', { latitude: lat, longitude: long })).then(response => {
        if (response.body) {
            const data = response.body;
            dispatch({
                type: actionTypes.ADD_BRANCHES,
                data,
            });
            callback();
        }
    });
};

const getPostOfficeService = (dispatch, postalCode, population, id, callback) => {
    Api.get(apiURLBuilder.getURL('getPostOfficeV3'), {
        header: {
            version: '3',
        },
        query: { postalCode, id, population },
    }).then(response => {
        if (response.body) {
            const data = response.body;
            const branch = data.oficinas[0];
            const address = `${branch.direccionOficina}, ${branch.codigoPostalOficina}, ${branch.poblacionOficina}`;
            const population = branch.poblacionOficina;
            const phone = branch.telefono || '-';
            const officeHours1 = branch.horarioOficina.split('/')[0].replace('DE ', '').toLowerCase().slice();
            const officeHours2 = branch.horarioOficina.split('/')[1].replace('DE ', '').toLowerCase();
            const officeHours3 = branch.horarioOficina.split('/')[2].replace('DE ', '').toLowerCase();
            const postalCode = branch.codigoPostalOficina;
            let days = 2;

            if (postalCode.startsWith('07')) {
                days = 3;
            }

            if (
                postalCode.startsWith('35') ||
                postalCode.startsWith('38') ||
                postalCode.startsWith('51') ||
                postalCode.startsWith('52')
            ) {
                days = 4;
            }

            const description =
                days == 4
                    ? formatText('identity-officeDays2', [days])
                    : formatText('identity-officeDays1', [days * 24]);

            dispatch(formActions.change('userProfile.postOfficeBranch', id));
            dispatch(formActions.change('userProfile.postOfficeAddress', address));
            dispatch(formActions.change('userProfile.postOfficePopulation', population));
            dispatch(formActions.change('userProfile.postOfficePhone', phone));
            dispatch(formActions.change('userProfile.postOfficeDescription', description));
            dispatch(
                formActions.change(
                    'userProfile.postOfficeHours1',
                    officeHours1.replace('DE ', '').toLowerCase().slice(4)
                )
            );
            dispatch(
                formActions.change(
                    'userProfile.postOfficeHours2',
                    officeHours2.replace('DE ', '').toLowerCase().slice(1)
                )
            );
            dispatch(
                formActions.change(
                    'userProfile.postOfficeHours3',
                    officeHours3.replace('DE ', '').toLowerCase().slice(9)
                )
            );
            callback(true);
        } else {
            callback(false);
        }
    });
};

const showMap = () => {
    return {
        type: actionTypes.SHOW_MAP,
    };
};

const hideMap = () => {
    return {
        type: actionTypes.HIDE_MAP,
    };
};

const getPostOffice = (postalCode, population, id, callback) => {
    return dispatch => {
        getPostOfficeService(dispatch, postalCode, population, id, callback);
    };
};

const getPostOfficeByLatLong = (lat, long, callback) => {
    return dispatch => {
        getCorreosBranchesByLatLongService(dispatch, lat, long, callback);
    };
};

const clearBranches = () => {
    return {
        type: actionTypes.CLEAR_BRANCHES,
    };
};

export default {
    showMap,
    hideMap,
    clearBranches,
    getPostOffice,
    getPostOfficeByLatLong,
};
